import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { getProviderPostAuthDestination } from "@/lib/providerAccessNavigation";
import { validateAuthToken } from "@/guards/validateAuthToken";
import { store } from "@/app/store";
import { getProvider } from "@/app/store/provider/providerSlice";
import { CliniciansPlusOnboardingForm } from "@/components/register/selfService/CliniciansPlusOnboardingForm";

export const Route = createFileRoute("/register/onboarding")({
  beforeLoad: async () => {
    validateAuthToken();

    const destination = await getProviderPostAuthDestination();

    if (destination !== "/register/onboarding") {
      if (destination === "/dashboard") {
        await store.dispatch(getProvider()).unwrap();
      }

      throw redirect({ to: destination });
    }
  },
  component: CliniciansPlusOnboarding,
});

function CliniciansPlusOnboarding() {
  const { t } = useTranslation();

  return (
    <main className="h-screen overflow-y-auto bg-beige p-8">
      <h1 className="text-3xl font-semibold">
        {t("selfServiceOnboarding.title", {
          defaultValue: "Complete your clinician profile",
        })}
      </h1>
      <p className="mt-4">
        {t("selfServiceOnboarding.intro", {
          defaultValue: "Complete your profile to continue.",
        })}
      </p>
      <section className="mx-auto mt-8 max-w-xl">
        <CliniciansPlusOnboardingForm />
      </section>
    </main>
  );
}
